import Script from "next/script";

export const Recaptcha = () => {
    return (
        <Script
            id="recaptchaScript"
            src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN}`}
            strategy="afterInteractive"
        />
    );
};
